import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import camelcaseKeys from 'camelcase-keys'
import StationWorkoutsDay, { StationClassDay, StationClassInfo } from '@src/data/station-workouts-day'
import WorkoutData from '@src/data/workout-data'

type StationWorkoutsResponse = { days: any[], workouts?: any[], class_days?: any[], classes?: any[] }

export type StationWorkouts = { days: StationWorkoutsDay[], workouts: WorkoutData[], classDays: StationClassDay[], classes: StationClassInfo[] }

export class ClubStatsService {

  apiClient: ApiClient = new ApiClient()

  getStationWorkouts (from: string, to: string): Promise<StationWorkouts> {
    return this.apiClient.get<StationWorkoutsResponse>(API.TRAINERS_API.CLUB_STATS_STATION_WORKOUTS, { from, to })
      .then(response => {
        const days = (response.days || []).map((attrs) =>
          new StationWorkoutsDay(camelcaseKeys({
            ...attrs,
            workouts: (attrs.workouts || []).map(workout => camelcaseKeys(workout))
          }))
        )
        const workouts = (response.workouts || []).map((workout: any) => new WorkoutData(camelcaseKeys(workout, { deep: true })))
        const classDays = (response.class_days || []).map((attrs) => ({
          date: attrs.date,
          count: attrs.count,
          classes: (attrs.classes || []).map(entry => camelcaseKeys(entry))
        }))
        const classes = (response.classes || []).map(attrs => camelcaseKeys(attrs) as StationClassInfo)
        return Promise.resolve({ days, workouts, classDays, classes })
      })
      .catch(error => {
        console.error('failed to retrieve club stats - station workouts', error)
        return Promise.reject(error)
      })
  }
}
